module.exports = __webpack_public_path__ + "static/media/menu-alt.9ee4c6a3.png";